<template>
  <!-- .exhibition-template-choice .etc -->
  <div class="layout-body etc">
    <div class="layout-header-bar">
      <!-- <div class="head-logo">
        <img
          src="@assets/img/exhibition/logo.png"
          alt="云展台"
          @click="$router.push('/exhibition/index/home')"
          class="f-csp"
        />
      </div> -->
      <div class="head-right">
        <div class="head-btn" @click="back">返回</div>
      </div>
    </div>
    <div class="layout-box">
      <h2 class="etc-title">{{originType}} / 选择模板</h2>
      <div class="etc-content">
        <Row :gutter="16">
          <Col span="6">
            <div
              class="etc-item"
              @click="$router.push('/exhibition/template/service-new' + queryType)"
            >
              <img src="@assets/img/template/temp-1.jpg" width="100%" />
              <div class="etc-item-info">
                <div class="etc-item-info__l">免费</div>
                <div class="etc-item-info__r">
                  <span>官方</span>
                  <img src="@assets/img/zsx-logo.png" />
                </div>
              </div>
              <div class="etc-mask">【服务商通用模板】</div>
            </div>
            <div class="etc-item-name">【服务商通用模板】</div>
          </Col>
          <Col span="6">
            <div
              class="etc-item"
              @click="$router.push('/exhibition/template/brand-new' + queryType)"
            >
              <img src="@assets/img/template/temp-2.jpg" width="100%" />
              <div class="etc-item-info">
                <div class="etc-item-info__l">免费</div>
                <div class="etc-item-info__r">
                  <span>官方</span>
                  <img src="@assets/img/zsx-logo.png" />
                </div>
              </div>
              <div class="etc-mask">【品牌商通用模板】</div>
            </div>
            <div class="etc-item-name">【品牌商通用模板】</div>
          </Col>
          <Col span="6">
            <div
              class="etc-item"
              @click="$router.push('/exhibition/template/franchisee-new' + queryType)"
            >
              <img src="@assets/img/template/temp-3.jpg" width="100%" />
              <div class="etc-item-info">
                <div class="etc-item-info__l">免费</div>
                <div class="etc-item-info__r">
                  <span>官方</span>
                  <img src="@assets/img/zsx-logo.png" />
                </div>
              </div>
              <div class="etc-mask">【加盟商商通用模板】</div>
            </div>
            <div class="etc-item-name">【加盟商商通用模板】</div>
          </Col>
          <Col span="6">
            <div
              class="etc-item"
              @click="$router.push('/exhibition/template/factory-new' + queryType)"
            >
              <img src="@assets/img/template/temp-4.jpg" width="100%" />
              <div class="etc-item-info">
                <div class="etc-item-info__l">免费</div>
                <div class="etc-item-info__r">
                  <span>官方</span>
                  <img src="@assets/img/zsx-logo.png" />
                </div>
              </div>
              <div class="etc-mask">【工厂通用模板】</div>
            </div>
            <div class="etc-item-name">【工厂通用模板】</div>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "exhibition-template-choice-new", // 选择模板
  data() {
    return {
      originType: "用户注册"
    };
  },
  created() {
    if (this.$route.query && this.$route.query.origin === "2") {
      this.originType = "云展台管理";
    }
  },
  computed: {
    queryType(val, oldVal) {
      const orign = this.$route.query.origin === "2" ? "?origin=2" : "";
      const type = this.$route.query.type === "add" ? "&type=add" : "";
      return orign + type;
    }
  },
  methods: {
    back() {
      if (this.$route.query && this.$route.query.origin === "2") {
        this.$router.push("/exhibition/index/exinfo/exhibition-info");
      } else {
        this.$router.push("/exhibition/index/home");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.etc {
  &-title {
    padding: 66px 0 44px;
    text-align: center;
  }
  &-mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(55, 55, 55, 0.6);
    height: 100%;
    color: #fff;
    opacity: 0;
    padding-top: 300px;
    text-align: center;
  }
  &-content {
    max-width: 1200px;
    min-height: 500px;
    margin: 0 auto;
  }
  &-item-name {
    text-align: center;
    width: calc(100% - 1px);
    font-size: 14px;
    color: #222;
    padding: 24px 0;
  }
  &-item {
    background: #fff;
    cursor: pointer;
    position: relative;
    &:hover {
      .etc-mask {
        opacity: 1;
      }
    }
    &-info {
      display: flex;
      padding: 0 10px;
      justify-content: center;
      line-height: 30px;
      &__l {
        width: 50%;
        display: flex;
        align-items: center;
      }
      &__r {
        width: 50%;
        text-align: right;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        span {
          display: inline-block;
          margin-right: 7px;
        }
        img {
          width: 24px;
          height: 24px;
        }
      }
    }
  }
}
.layout-box {
  padding-bottom: 60px;
  background: #f0f2f5;
  min-width: 1000px;
  &-top {
    box-shadow: 0px 0px 7px 0px rgba(146, 160, 185, 0.2);
    background: #fff;
  }
  &-tool {
    line-height: 54px;
    padding: 0 24px;
  }
}
.layout-body {
  height: 100%;
  background: #fff;
}
.layout-header-bar {
  display: flex;
  background: #002140;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}
.head-logo {
  height: 64px;
  padding-top: 16px;
  padding-left: 19px;
}
.head-right {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.head-btn {
  font-size: 18px;
  color: #ededed;
  padding-right: 45px;
  display: inline-block;
  cursor: pointer;
}
</style>
